import { useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@mantine/core';
import { IMaskInput } from 'react-imask';
import { DatePicker } from '@mantine/dates';
import { formatDate, stringToDate } from '@/helpers/date';
import { useClickOutside } from '@mantine/hooks';
import { IconCalendarMonth } from '@tabler/icons-react';
import classes from './dateInput.module.css';
import 'dayjs/locale/he';

const DateInput = (props) => {
  const {
    minDate,
    maxDate,
    label,
    form,
    description,
    withAsterisk,
    test,
  } = props;

  const [date, setDate] = useState('');
  const [valueDatepicker, setValueDatepicker] = useState(stringToDate(form?.value));
  const [open, setOpen] = useState(false);
  const ref = useClickOutside(() => setOpen(false));

  const handleButtonClick = () => {
    setOpen(true);
  };

  const icon = (
    <button className={classes.button} onClick={handleButtonClick}>
      <IconCalendarMonth stroke={1} />
    </button>
  );

  const handleDateChange = (dte) => {
    const d = formatDate(dte);
    form.onChange(d);
    setValueDatepicker(dte);
    setOpen(false);
    form.onBlur(d);
  };

  const handleInputChange = (event) => {
    let newValue = event.target.value;
    newValue = newValue.replace(/[^\d/]/g, '');

    if (newValue.startsWith('/')) {
      newValue = newValue.substring(1);
    }

    const countSlashes = (newValue.match(/\//g) || []).length;
    const parts = newValue.split('/');
    if (parts.length > 3) {
      newValue = `${parts[0]}/${parts[1]}/${parts[2]}`;
    }

    if (countSlashes === 1 && parts[0].length === 1) {
      newValue = `0${parts[0]}/${parts[1] || ''}`;
    }

    if (countSlashes === 2 && parts[1]?.length === 1) {
      newValue = `${parts[0]}/0${parts[1]}/${parts[2] || ''}`;
    }

    if (newValue.length === 3 && !newValue.includes('/')) {
      newValue = `${newValue.substring(0, 2)}/${newValue.substring(2)}`;
    }

    if (newValue.length === 6 && !newValue.includes('/', 3)) {
      newValue = `${newValue.substring(0, 5)}/${newValue.substring(5)}`;
    }

    form.onChange(newValue);
    const formattedDate = stringToDate(newValue);
    setValueDatepicker(formattedDate);
    setDate(formattedDate);
  };

  return (
    <div className={classes.datepicker} ref={ref}>
      <TextInput
        data-f={test}
        label={label}
        description={description}
        rightSection={icon}
        {...form}
        onChange={handleInputChange}
        maxLength={10}
        withAsterisk={withAsterisk}
        placeholder='dd/mm/yyyy'
        component={IMaskInput}
        mask="00/00/0000"
      />

      {open && (
        <div className={classes.calendar}>
          <DatePicker
            firstDayOfWeek={0}
            weekendDays={[6]}
            locale="he"
            minDate={minDate}
            maxDate={maxDate}
            value={valueDatepicker}
            onChange={handleDateChange}
            date={date}
            onDateChange={setDate}
          />
        </div>
      )}
    </div>
  );
};

DateInput.propTypes = {
  minDate: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  test: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  form: PropTypes.object,
  withAsterisk: PropTypes.bool,
};

export default DateInput;
